module.exports = __webpack_public_path__ + "img/office.185479cc.svg";